import React from 'react'
import ImageWithFallback from './ImageWithFallback'

export default function ProductLogo({ short = false, dark = false, extension = "svg", ...restProps }) {
    const logoName = window.location.hostname.split(".")[0];
    const src = `/images/product-logos/${logoName}${short ? "-short" : ""}${dark ? "-dark" : ""}.${extension}`;
    const fallbackSrc = `/images/product-logos/app${short ? "-short" : ""}${dark ? "-dark" : ""}.${extension}`;
    return (
        <ImageWithFallback src={window.location.origin + src} fallbackSrc={window.location.origin + fallbackSrc} alt="Logo"  fallbackExtensions={["png", "jpg"]} {...restProps} />
    )
}
